import React, { useCallback } from "react";
import cn from "classnames";
import T from "prop-types";

import TextComponent from "b2b/components/text-component";

import ZadostiGroupsPocet from "./ZadostiGroupsPocet";

function ZadostiGroupsZdroj({ data, isActive, label, loading, onChange }) {
  const onClickCallback = useCallback(() => {
    onChange(data.zdroj);
  }, []);
  const pocet = data.pocet;
  const isDisabled = !pocet || loading;
  return (
    <div
      className={cn("b2b-ZadostiGroups-zdroj", {
        "is-active": isActive,
        "is-disabled": isDisabled
      })}
      onClick={!isDisabled ? onClickCallback : undefined}
    >
      <TextComponent loading={loading}>{label}</TextComponent>
      {!isDisabled ? <ZadostiGroupsPocet pocet={pocet} /> : undefined}
    </div>
  );
}

ZadostiGroupsZdroj.propTypes = {
  data: T.object.isRequired,
  isActive: T.bool,
  label: T.string,
  loading: T.bool,
  onChange: T.func.isRequired
};

export default React.memo(ZadostiGroupsZdroj);
